import service from '@/services';

import { unwrapDataArray, type MaybeDataEnvelope } from './response-envelope';

export type SignAgreementsRequest = {
  agreement_ids: string[];
};

export type RiaAgreement = {
  agreement_id: string;
  url: string;
  title: string;
  description: string;
  version: string;
  created_at: string;
  last_updated_at: string;
};

export type SignedAgreementSignature = {
  advisor_cognito_id: string;
  agreement_id: string;
  version: string;
  signed_at: string;
  consent_type: string;
};

export type SignedAgreement = {
  signature: SignedAgreementSignature;
  agreement: RiaAgreement;
};

export type GetSignedAgreementsResponse = SignedAgreement[];

export const getSignedAgreements = async (): Promise<GetSignedAgreementsResponse> => {
  const url = `/ria-agreements/signed`;
  try {
    const response = await service.getByParams<MaybeDataEnvelope<SignedAgreement>>(url);
    return unwrapDataArray<SignedAgreement>(response);
  } catch (error) {
    console.error('Failed to fetch signed agreements:', error);
    throw error;
  }
};

export const signAgreements = async (data: SignAgreementsRequest): Promise<void> => {
  const url = `/ria-agreements/sign`;
  try {
    await service.post(url, data);
  } catch (error) {
    console.error('Failed to sign agreements:', error);
    throw error;
  }
};
